import { createFileRoute, redirect } from "@tanstack/react-router";
import { CityInsightsPage } from "@/app/partner/pages/dashboard/PartnerInsights/CityInsightsPage";
import { validateInsightsSearch } from "@/app/partner/pages/dashboard/PartnerInsights/state";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/insights/cities")({
	validateSearch: validateInsightsSearch,
	beforeLoad: async ({ context }) => {
		if (!canAccessRoute(context.partner, "dashboard").allowed) {
			throw redirect({ to: "/flex/dashboard/leads" });
		}
	},
	component: CityInsightsPage,
});
